import { useEffect, useImperativeHandle, useState, forwardRef } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { Select } from "../Helper";
const AddressForm = forwardRef(function AddressForm(
  {
    prefilled = {
      address_line1: "",
      address_line2: "",
      address_pin_id: "",
      pincode: "",
      office_name: "",
      district: "",
      state_name: "",
    },
  },
  ref
) {
  const url = process.env.REACT_APP_API_ENDPOINT + "/PinCode/?key=";
  const [formInputData, setFormInputData] = useState(prefilled);
  const [postOffices, setPostOffices] = useState([]);
  async function fetchAddress() {
    if (formInputData.pincode.length === 6) {
      try {
        const response = await fetch(url + formInputData.pincode).then((res) =>
          res.json()
        );
        if (response.success) {
          if (response.response.length > 0) {
            let firstAddress = response.response[0];
            formInputData.district = firstAddress.district;
            formInputData.state_name = firstAddress.state_name;
            formInputData.address_pin_id = firstAddress.address_pin_id;
          }
          setPostOffices(response.response);
        }
      } catch (ex) {
        console.log(ex);
      }
    } else {
      formInputData.district = "";
      formInputData.state_name = "";
      formInputData.address_pin_id = "";
    }
    setFormInputData({ ...formInputData });
  }
  useEffect(() => {
    fetchAddress();
  }, [formInputData.pincode]);
  const handleInputChange = (evnt) => {
    const inputFieldValue = evnt.target.value;
    const inputFieldName = evnt.target.name;
    const NewInputValue = {
      ...formInputData,
      [inputFieldName]: inputFieldValue,
    };
    setFormInputData(NewInputValue);
  };

  useImperativeHandle(
    ref,
    () => {
      return {
        value: { ...formInputData },
      };
    },
    [formInputData]
  );

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="Address Line 1"
          required
          name="address_line1"
          value={formInputData.address_line1}
          onChange={handleInputChange}
          minLength="10"
          maxLength="75"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="Address Line 2"
          name="address_line2"
          value={formInputData.address_line2}
          onChange={handleInputChange}
          minLength="3"
          maxLength="75"
        />
      </Form.Group>

      <Row>
        <Col>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Pin Code"
              required
              name="pincode"
              value={formInputData.pincode}
              onChange={handleInputChange}
              minLength="6"
              maxLength="6"
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3">
            <Select
              inputProps={{
                required: true,
                name: "address_pin_id",
                value: formInputData.address_pin_id,
                onChange: handleInputChange,
              }}
              options={postOffices}
              defaultLabel="Post Office"
              valueElement="address_pin_id"
              displayElement="office_name"
            />
            {/* <Form.Select
                aria-label="Post Office"
                required
                name="address_pin_id"
                value={formInputData.address_pin_id}
                onChange={handleInputChange}
              >
                <option value="">City</option>
                <option value="1">Kolkata</option>
                <option value="2">Mumbai</option>
                <option value="3">Patna</option>
              </Form.Select> */}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3">
            <Form.Control
              placeholder="District"
              readOnly
              name="district"
              value={formInputData.district}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3">
            <Form.Control
              placeholder="State"
              readOnly
              name="state"
              value={formInputData.state_name}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
});

export default AddressForm;
